<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <div class="fwc-container">
    <div class="fwc-row fwc-row-bm">
      <div class="fwc-input">
        <label for="Email">Email</label>
        <input formControlName="email" name="Email" id="Email" type="text"
          attr.aria-invalid="{{submitted && form.email.errors ? true : false}}" maxlength="255" />
        @if (submitted && form.email.errors) {
          <span role="alert" class="fwc-inline-icon fwc-icon-delete"
          id="state_error">Please enter a valid email</span>
        }
      </div>
    </div>
    <!-- <div class="fwc-row fwc-row-bm">
      @if (participantId) {
        <a href="javascript:void(0)" (click)="navigateTo(participantId+'/forgot-password')">Forgot your password?</a>
      }
      @if (storyId) {
        <a href="javascript:void(0)" (click)="navigateTo('school/'+ storyId +'/forgot-password')">Forgot your password?</a>
      }
    </div> -->
    <div class="fwc-row fwc-row-bm">
      <button class="fwc-btn fwc-btn-primary">{{content.button}}</button>
    </div>
  </div>

</form>
@if (displaySpinner) {
  <div class="ant-ui-widget-overlay"></div>
  <div class="ant-ajax-loader">
    <fwc-preloader></fwc-preloader>
  </div>
}
